var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17489 1.57501L15.5991 2.63626L16.6596 10.0613L9.76564 16.9553C9.62499 17.0959 9.43426 17.1748 9.23539 17.1748C9.03651 17.1748 8.84578 17.0959 8.70514 16.9553L1.28014 9.53026C1.13953 9.38962 1.06055 9.19888 1.06055 9.00001C1.06055 8.80114 1.13953 8.61041 1.28014 8.46976L8.17489 1.57501ZM8.70514 3.16651L2.87089 9.00001L9.23539 15.3638L15.0689 9.53026L14.2739 3.96151L8.70514 3.16651ZM10.2951 7.93951C10.0138 7.65805 9.85575 7.27635 9.85582 6.87837C9.85585 6.68131 9.8947 6.48619 9.97014 6.30415C10.0456 6.12211 10.1561 5.9567 10.2955 5.81739C10.4349 5.67807 10.6003 5.56757 10.7824 5.49219C10.9645 5.41681 11.1596 5.37803 11.3567 5.37807C11.7546 5.37814 12.1363 5.5363 12.4176 5.81776C12.699 6.09922 12.857 6.48093 12.857 6.8789C12.8569 7.27688 12.6987 7.65852 12.4173 7.93989C12.1358 8.22125 11.7541 8.37927 11.3561 8.3792C10.9581 8.37913 10.5765 8.22097 10.2951 7.93951Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.7aa69cfa.svg";
export { ForwardRef as ReactComponent };